export default __webpack_public_path__ + "static/media/oscer-pres-erectile-dysfunction.53e15039.svg";